const setupGformSpinner = ($) => {
	const TRANSPARENT_SPINNER =
		'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';

	const clearSpinnerButton = (button) => {
		button.classList.remove('gform-has-spinner');
		button.removeAttribute('aria-busy');

		if (button.style.webkitTextFillColor === 'transparent') {
			button.style.webkitTextFillColor = '';
		}
	};

	const removeAjaxSpinner = (formId) => {
		const spinner = document.getElementById(
			'gform_ajax_spinner_' + formId
		);

		if (spinner) {
			spinner.remove();
		}

		const form = document.getElementById('gform_' + formId);

		if (!form) {
			return;
		}

		form.querySelectorAll('.gform-has-spinner').forEach(clearSpinnerButton);
	};

	// Gravity Forms 3 appends the loader inside the submit button and only
	// removes loaders found inside the form. Move it to the body so the
	// full-page overlay is not clipped by an ancestor, then remove it once
	// the submission settles.
	const promoteSpinner = (node) => {
		if (!(node instanceof Element)) {
			return;
		}

		if (
			!node.isConnected ||
			!node.id ||
			node.id.indexOf('gform_ajax_spinner_') !== 0
		) {
			return;
		}

		if (node.tagName === 'IMG') {
			node.src = TRANSPARENT_SPINNER;
		}

		if (node.parentElement !== document.body) {
			document.body.appendChild(node);
		}

		// Hide may have been created after the first wrap attempt.
		wrapSpinnerHide();
	};

	const observer = new MutationObserver((mutations) => {
		mutations.forEach((mutation) => {
			mutation.addedNodes.forEach((node) => {
				promoteSpinner(node);

				if (node.querySelectorAll) {
					node
						.querySelectorAll('[id^="gform_ajax_spinner_"]')
						.forEach(promoteSpinner);
				}
			});
		});
	});

	observer.observe(document.documentElement, {
		childList: true,
		subtree: true,
	});

	const wrapSpinnerHide = () => {
		if (
			typeof gform === 'undefined' ||
			!gform.spinner ||
			typeof gform.spinner.hide !== 'function' ||
			gform.spinner.hide.__ijOverlay
		) {
			return;
		}

		const originalHide = gform.spinner.hide;

		gform.spinner.hide = function () {
			const result = originalHide.apply(this, arguments);

			document
				.querySelectorAll('[id^="gform_ajax_spinner_"]')
				.forEach((spinner) => spinner.remove());

			document
				.querySelectorAll(
					'.gform-has-spinner, .gform_wrapper [aria-busy="true"]'
				)
				.forEach(clearSpinnerButton);

			return result;
		};

		gform.spinner.hide.__ijOverlay = true;
	};

	const useTransparentSpinner = () => {
		if (
			typeof gform === 'undefined' ||
			typeof gform.addFilter !== 'function' ||
			useTransparentSpinner.done
		) {
			return;
		}

		gform.addFilter('gform_spinner_url', function () {
			return TRANSPARENT_SPINNER;
		});
		useTransparentSpinner.done = true;
	};

	wrapSpinnerHide();
	useTransparentSpinner();
	window.addEventListener('load', function () {
		wrapSpinnerHide();
		useTransparentSpinner();
	});
	// Footer forms load Gravity Forms after window load, then dispatch this
	// event once gform.spinner exists.
	document.addEventListener('gform/theme/scripts_loaded', function () {
		wrapSpinnerHide();
		useTransparentSpinner();
	});

	$(document).on(
		'gform_confirmation_loaded gform_page_loaded gform_post_render',
		function (_event, formId) {
			removeAjaxSpinner(formId);
		}
	);
};

setupGformSpinner(jQuery);

const globalHeaderNavigation = () => {
	const header = document.querySelector('.site-navbar');

	if (!header) {
		return;
	}

	const toggle = header.querySelector('.navbar-toggle');
	const navigation = header.querySelector('#navbar-content');

	if (!toggle || !navigation) {
		return;
	}

	const updateToggleLabel = (expanded) => {
		const label = expanded ? 'Close menu' : 'Open menu';
		const hiddenLabel = toggle.querySelector('.navbar-toggle__label');

		toggle.setAttribute('aria-label', label);
		if (hiddenLabel) {
			hiddenLabel.textContent = label;
		}
	};

	navigation.addEventListener('show.bs.collapse', () => updateToggleLabel(true));
	navigation.addEventListener('hidden.bs.collapse', () => updateToggleLabel(false));

	const searchForm = header.querySelector('.desktop-nav .ubermenu-searchform');
	const searchItem = searchForm
		? searchForm.closest('.ubermenu-item-level-0')
		: null;

	if (!searchItem) {
		return;
	}

	const searchTrigger = searchItem.querySelector(':scope > .ubermenu-target');
	const searchInput = searchForm.querySelector('.ubermenu-search-input');

	const setSearchExpanded = (expanded) => {
		header.classList.toggle('is-search-open', expanded);
		searchItem.classList.toggle('is-inline-search-open', expanded);
		searchItem.classList.remove('ubermenu-active', 'ubermenu-in-transition');

		if (searchTrigger) {
			searchTrigger.setAttribute('aria-expanded', expanded.toString());
		}

		if (expanded && searchInput) {
			searchInput.focus({ preventScroll: true });

			window.requestAnimationFrame(() => {
				if (searchItem.classList.contains('is-inline-search-open')) {
					searchInput.focus({ preventScroll: true });
				}
			});
		}
	};

	if (searchTrigger && searchInput) {
		searchTrigger.addEventListener(
			'click',
			(event) => {
				event.preventDefault();
				event.stopImmediatePropagation();
				setSearchExpanded(
					!searchItem.classList.contains('is-inline-search-open')
				);
			},
			true
		);

		searchInput.addEventListener('keydown', (event) => {
			if (event.key === 'Escape') {
				event.preventDefault();
				setSearchExpanded(false);
				searchTrigger.focus({ preventScroll: true });
			}
		});
	}

	document.addEventListener('click', (event) => {
		if (
			searchItem.classList.contains('is-inline-search-open') &&
			!searchItem.contains(event.target)
		) {
			setSearchExpanded(false);
		}
	});

	setSearchExpanded(false);
};

globalHeaderNavigation();

const filterToggle = ($) => {
	const $component = $('#filters-component');
	const $toggle = $('#filter-toggle');
	const $collapse = $('#filter-collapse');

	const toggleFilters = () => {
		if ($component.hasClass('animating')) {
			return;
		}

		const isExpanded =
			$toggle.attr('aria-expanded') === 'false' ? false : true;

		if (isExpanded) {
			return closeCollapse();
		}

		openCollapse();
	};

	const closeCollapse = () => {
		const height = $collapse.get(0).scrollHeight;

		$component.removeClass('opened').addClass('closing animating');

		$collapse.css({ height });

		$collapse.animate(
			{
				height: 0,
			},
			400,
			() => {
				$toggle.attr('aria-expanded', 'false');
				$component.addClass('closed').removeClass('closing animating');
				$collapse.removeAttr('style');
			}
		);
	};

	const openCollapse = () => {
		const height = $collapse.get(0).scrollHeight;

		$component.removeClass('closed').addClass('opening animating');

		$collapse.animate(
			{
				height,
			},
			400,
			() => {
				$toggle.attr('aria-expanded', 'true');
				$component.addClass('opened').removeClass('opening animating');
				$collapse.removeAttr('style');
			}
		);
	};

	return {
		init() {
			if (!$toggle.length) {
				return;
			}

			this.bind();
		},
		bind() {
			$toggle.on('click', () => {
				toggleFilters();
			});
		},
	};
};

filterToggle(jQuery).init();

const smoothScrollTo = ($) => {
	const $scrollTo = $('#scroll-to-links');

	return {
		init() {
			if (!$scrollTo.length) {
				return;
			}

			this.bind();
		},
		bind() {
			$scrollTo.find('a[href^="#"]').on('click', (e) => {
				e.preventDefault();

				const id = $(e.currentTarget).attr('href');

				$('html, body').animate(
					{
						scrollTop: $(id).offset().top,
					},
					500
				);
			});
		},
	};
};

smoothScrollTo(jQuery).init();

// View more overlay button, used on issue landing pages
const viewAdditionalContent = ($) => {
	const $toggleButton = $('.read-more-overlay .btn');

	return {
		init() {
			if (!$toggleButton.length) {
				return;
			}

			this.bind();
		},
		bind() {
			$toggleButton.on('click', (e) => {
				e.preventDefault();

				if ($toggleButton.hasClass('active')) {
					$toggleButton.html('Continue Reading');
				} else {
					$toggleButton.html('View Less');
				}

				$toggleButton.toggleClass('active');
				$toggleButton
					.closest('.read-more-overlay')
					.toggleClass('active');
				$toggleButton
					.closest('.container')
					.find('.additional-content')
					.slideToggle();
			});
		},
	};
};

viewAdditionalContent(jQuery).init();

const viewAdditionalCards = ($) => {
	const $toggleButton = $('.view-more-toggle .more .btn');

	return {
		init() {
			if (!$toggleButton.length) {
				return;
			}

			this.bind();
		},
		bind() {
			$toggleButton.on('click', (e) => {
				e.preventDefault();
				const $btn = $(e.currentTarget);

				if ($btn.hasClass('active')) {
					$btn.html('Load More').toggleClass('active');
					$btn.closest('.view-more-toggle')
						.find('.show-toggle')
						.removeClass('show-toggle')
						.slideToggle();
				} else {
					$btn.html('View Less').toggleClass('active');
					$btn.closest('.view-more-toggle')
						.find('article:hidden')
						.addClass('show-toggle')
						.slideToggle();
				}
			});
		},
	};
};

viewAdditionalCards(jQuery).init();

const galleryLightbox = ($) => {
	const $galleryLinks = $('[data-target="gallery"]');
	const $galleryCarousel = $('#gallery-carousel');
	const $galleryModal = $('#gallery-modal');

	return {
		init() {
			if (!$galleryLinks.length) {
				return;
			}

			this.bind();
		},
		bind() {
			$galleryLinks.on('click', (e) => {
				e.preventDefault();

				const $link = $(e.currentTarget);
				const index = parseInt($link.attr('data-index'));
				bootstrap.Modal.getOrCreateInstance($galleryModal[0]).show();
				bootstrap.Carousel.getOrCreateInstance($galleryCarousel[0], {
					interval: false,
					ride: false,
				}).to(index);
			});
		},
	};
};

galleryLightbox(jQuery).init();

const mediaGalleryToggle = ($) => {
	const $toggles = $('[data-media-gallery-toggle]');

	return {
		init() {
			if (!$toggles.length) {
				return;
			}

			this.bind();
		},
		bind() {
			$toggles.on('click', (e) => {
				const $toggle = $(e.currentTarget);
				const isExpanded = $toggle.attr('aria-expanded') === 'true';
				const $additionalImages = $toggle
					.siblings('.media-gallery')
					.find('.gallery-link--additional');

				$additionalImages.prop('hidden', isExpanded);
				$toggle
					.attr('aria-expanded', (!isExpanded).toString())
					.toggleClass('active', !isExpanded)
					.find('.media-gallery-toggle__label')
					.text(isExpanded ? 'See More' : 'See Less');
			});
		},
	};
};

mediaGalleryToggle(jQuery).init();

const caseDocumentsToggle = ($) => {
	const $toggleButtons = $('[data-documents-toggle]');

	return {
		init() {
			if (!$toggleButtons.length) {
				return;
			}

			this.bind();
		},
		bind() {
			$toggleButtons.on('click', (event) => {
				const $button = $(event.currentTarget);
				const isExpanded = $button.attr('aria-expanded') === 'true';
				const $feed = $button.siblings('.feed-wrapper');

				$feed.find('.document-card--additional').prop('hidden', isExpanded);
				$button
					.attr('aria-expanded', (!isExpanded).toString())
					.toggleClass('active', !isExpanded)
					.find('.documents-toggle__label')
					.text(isExpanded ? 'More Documents' : 'Fewer Documents');
			});
		},
	};
};

caseDocumentsToggle(jQuery).init();

const relatedMediaToggle = ($) => {
	$('[data-related-media-toggle]').on('click', (event) => {
		const $button = $(event.currentTarget);
		const isExpanded = $button.attr('aria-expanded') === 'true';
		const $additional = $button.siblings('.related-media-feed__additional');
		const duration = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 300;

		$additional.stop(true, true);
		if (isExpanded) {
			$additional.slideUp(duration, () => {
				$additional.prop('hidden', true);
			});
		} else {
			$additional.hide().prop('hidden', false).slideDown(duration);
		}

		$button
			.attr('aria-expanded', (!isExpanded).toString())
			.toggleClass('active', !isExpanded)
			.find('.related-media-toggle__label')
			.text(isExpanded ? 'Additional News' : 'Less News');
	});
};

relatedMediaToggle(jQuery);

const pressReleaseToggle = ($) => {
	const $toggle = $('#resources-toggle');
	const $wrapper = $('#resources-aux');

	const openResources = () => {
		const $content = $wrapper.children().first();
		$content.css({ display: 'block' });

		const height = $wrapper.get(0).scrollHeight;

		$wrapper.animate(
			{
				height,
			},
			400,
			() => {
				$wrapper
					.addClass('expanded')
					.removeClass('closed')
					.removeAttr('style');
			}
		);

		$('html, body').animate(
			{
				scrollTop: $('#resources-aux').offset().top,
			},
			500
		);
	};

	return {
		init() {
			if (!$toggle.length) {
				return;
			}

			this.bind();
		},
		bind() {
			$toggle.on('click', () => {
				openResources();
			});
		},
	};
};

pressReleaseToggle(jQuery).init();

(function ($) {
	class Pagination {
		constructor($component) {
			this.$pagination = $component;
			this.$select = $component.find('[data-pagination="select"]');

			this.init = this.init.bind(this);

			this.init();
		}

		init() {
			this.$select.on('change', (e) => {
				window.location.href = e.target.value;
			});
		}
	}

	$.fn.pagination = function () {
		this.each(function () {
			new Pagination($(this));
		});
	};

	$('[data-pagination="component"]').pagination();
})(jQuery);

const archiveTabPagination = ($) => {
	const $archiveTabs = $('#archive-tabs');
	const pagesToShow = 5;
	let $navItems, pagesToShowBefore, pagesToShowAfter, totalPages;

	const updatePagination = (newPage) => {
		newPage = parseInt(newPage);
		let startPage;
		const canShowAllBefore = newPage - pagesToShowBefore > 0 ? true : false;
		const canShowAllAfter =
			newPage + pagesToShowAfter <= totalPages ? true : false;

		if (!canShowAllBefore && canShowAllAfter) {
			startPage = 1;

			$('#nav-first').hide();
			$('#nav-last').show();
		}

		if (canShowAllBefore && canShowAllAfter) {
			startPage = newPage - pagesToShowBefore;

			$('#nav-first, #nav-last').show();
		}

		if (canShowAllBefore && !canShowAllAfter) {
			startPage = totalPages - pagesToShow + 1;

			$('#nav-first').show();
			$('#nav-last').hide();
		}

		updateNavItems(startPage);

		if (newPage === 1) {
			$('#nav-prev').hide();
		} else {
			$('#nav-prev').show();
		}

		if (newPage === totalPages) {
			$('#nav-next').hide();
		} else {
			$('#nav-next').show();
		}
	};

	const updateNavItems = (startPage) => {
		const startIndex = startPage - 1;
		const endIndex = startIndex + pagesToShow;

		$navItems.each(function (i) {
			if (i >= startIndex && i < endIndex) {
				$(this).show();
			} else {
				$(this).hide();
			}
		});
	};

	const getCurrentPage = () => {
		const $active = $archiveTabs.find('.nav-link.active');
		return parseInt($active.attr('data-page'));
	};

	const gotoPage = (page) => {
		const $page = $archiveTabs.find(`.nav-link[data-page="${page}"]`);
		bootstrap.Tab.getOrCreateInstance($page[0]).show();
	};

	return {
		init() {
			if (!$archiveTabs.length) {
				return;
			}

			$navItems = $archiveTabs.find('.nav-item:not(.nav-control)');

			totalPages = $('a[data-bs-toggle="tab"]').length;

			if (pagesToShow % 2 === 0) {
				pagesToShowBefore = pagesToShow / 2;
				pagesToShowAfter = pagesToShow / 2 - 1;
			} else {
				pagesToShowBefore = (pagesToShow - 1) / 2;
				pagesToShowAfter = (pagesToShow - 1) / 2;
			}

			updatePagination(1);

			this.bind();
		},
		bind() {
			$archiveTabs
				.find('a[data-bs-toggle="tab"]')
				.on('shown.bs.tab', (e) => {
					const $newTab = $(e.target);
					const newPage = $newTab.attr('data-page');
					$('#nav-select').val($newTab.attr('id'));
					updatePagination(newPage);
				});

			$archiveTabs
				.find('a[data-toggle="tabcontrol"]')
				.on('click', (e) => {
					e.preventDefault();

					const $control = $(e.currentTarget);
					const href = $control.attr('href').substring(1);

					if (href === 'first') {
						gotoPage(1);
					}

					if (href === 'prev') {
						gotoPage(getCurrentPage() - 1);
					}

					if (href === 'next') {
						gotoPage(getCurrentPage() + 1);
					}

					if (href === 'last') {
						gotoPage(totalPages);
					}
				});

			$('#nav-select').on('change', (e) => {
				const tabId = `#${$(e.currentTarget).val()}`;
				bootstrap.Tab.getOrCreateInstance(
					document.querySelector(tabId)
				).show();
			});
		},
	};
};

archiveTabPagination(jQuery).init();

const stickySidebar = ($) => {
	const $feed = $('#all-staff-feeds');
	const $wrapper = $feed.find('.layout-wrapper');
	const $panel = $feed.find('.feed-scroll-to');
	const $sidebar = $panel.parent('.feed-sidebar');
	let windowPos, feedPos, lastWindowPos, isFixedTop, isFixedBottom;

	const isDesktop = () => {
		return $wrapper.css('display') === 'flex' ? true : false;
	};

	const fixTop = () => {
		$panel.removeAttr('style');

		const width = $sidebar.width();

		$panel.css({
			position: 'fixed',
			top: 0,
			width,
		});

		isFixedTop = true;
		isFixedBottom = false;
	};

	const fixBottom = () => {
		$panel.removeAttr('style');

		const width = $sidebar.width();

		$panel.css({
			position: 'absolute',
			bottom: '42px',
			width,
		});

		isFixedTop = false;
		isFixedBottom = true;
	};

	const unFix = () => {
		$panel.removeAttr('style');
		isFixedTop = false;
	};

	const getSidebarPos = () => {
		const sidebarHeight = $sidebar.height();
		const sidebarPos = $sidebar.offset().top;
		const panelHeight =
			$panel.height() + parseInt($panel.css('margin-top'), 10);
		return parseInt(
			sidebarHeight + sidebarPos - windowPos - panelHeight - 90
		);
	};

	const setInitial = () => {
		windowPos = $(window).scrollTop();
		lastWindowPos = windowPos;
		feedPos = $feed.offset().top;
		isFixedTop = false;
		isFixedBottom = false;
		const sidebarPos = getSidebarPos();

		if (windowPos >= feedPos) {
			fixTop();
		}

		if (sidebarPos <= 0) {
			fixBottom();
		}
	};

	return {
		init() {
			if (!$feed.length) {
				return;
			}

			if (isDesktop()) {
				setInitial();
			}

			this.bind();
		},
		bind() {
			$(window).resize(() => {
				if (isDesktop()) {
					setInitial();
				} else {
					$panel.removeAttr('style');
				}
			});

			$(window).scroll(() => {
				if (!isDesktop()) {
					return;
				}

				windowPos = $(window).scrollTop();
				const sidebarPos = getSidebarPos();
				const isScrollingDown =
					windowPos > lastWindowPos ? true : false;

				if (
					!isFixedTop &&
					!isFixedBottom &&
					isScrollingDown &&
					windowPos >= feedPos
				) {
					fixTop();
				}

				if (isFixedTop && !isScrollingDown && windowPos < feedPos) {
					unFix();
				}

				if (!isFixedBottom && isScrollingDown && sidebarPos <= 0) {
					fixBottom();
				}

				if (isFixedBottom && !isScrollingDown && sidebarPos > 0) {
					fixTop();
				}

				lastWindowPos = windowPos;
			});
		},
	};
};

stickySidebar(jQuery).init();

const feedAjax = ($) => {
	const $filteredFeed = $('#filtered-feed');
	let $filters, $feedWrapper, postType, topic, status;
	const $spinner = `
		<div class="spinner-wrapper" id="spinner">
			<div class="spinner-border" role="status">
				<span class="visually-hidden">Loading...</span>
			</div>
		</div>`;
	const setFilters = () => {
		topic = [];
		$('input[name="pillar"]:checked').each(function () {
			topic.push(this.value);
		});

		status = [];
		$('input[name="status"]:checked').each(function () {
			status.push(this.value);
		});
	};

	const getData = () => {
		return new Promise((resolve, reject) => {
			$.ajax({
				type: 'POST',
				url: '/wp-admin/admin-ajax.php',
				dataType: 'json',
				data: {
					action: 'get_more_ajax',
					postType,
					topic,
					status,
				},
				success: (response) => {
					return resolve(response);
				},
				error: (response) => {
					return reject(response);
				},
			});
		});
	};

	const updateFeed = () => {
		setFilters();

		$feedWrapper.html('').append($spinner);

		getData()
			.then((data) => {
				renderFeed(data);
			})
			.catch();
	};

	const renderFeed = (data) => {
		$('#spinner').remove();
		$('#cases-intro').addClass('d-none');

		window.history.pushState(
			'',
			'',
			'/cases/?&status-filter=' + status + '&topic-filter=' + topic
		);

		// Add markup
		if (data.markup === '') {
			$feedWrapper.append(
				'<p class="no-results">No Results Found...</p>'
			);
		} else {
			$feedWrapper.append(data.markup);
		}
		$(window).scrollTop(0);
	};

	return {
		init() {
			if (!$filteredFeed.length) {
				return;
			}

			$filters = $filteredFeed.find('.form-check');
			$feedWrapper = $filteredFeed.find('.feed-main');
			postType = $filteredFeed.attr('data-post-type');

			setFilters();

			this.bind();
		},
		bind() {
			$filters.on('change', () => {
				updateFeed();
			});
		},
	};
};

feedAjax(jQuery).init();

const footerSearchForm = ($) => {
	const $searchIcon = $('#site-footer .searchform .search-icon');
	const $searchForm = $('#site-footer .searchform');
	return {
		init() {
			if (!$searchIcon.length) {
				return;
			}
			this.bind();
		},
		bind() {
			$searchIcon.on('click', () => {
				$searchForm.submit();
			});
		},
	};
};

footerSearchForm(jQuery).init();

// Build the case Overview navigation from headings in the adjoining column.
const caseOverviewNavigation = () => {
	const navigationBlocks = document.querySelectorAll(
		'[data-case-overview-nav]:not(.is-preview)'
	);

	if (!navigationBlocks.length) {
		return;
	}

	const columnSelector = '.wp-block-column, .wp-block-kadence-column';

	const findAdjoiningColumn = (block) => {
		const currentColumn = block.closest(columnSelector);

		if (!currentColumn || !currentColumn.parentElement) {
			return null;
		}

		const columns = Array.from(currentColumn.parentElement.children).filter(
			(column) => column.matches(columnSelector)
		);
		const currentIndex = columns.indexOf(currentColumn);

		if (currentIndex === -1 || columns.length < 2) {
			return null;
		}

		// The Overview is normally in the right column, so prefer the closest
		// preceding column and fall back to the closest following column.
		return (
			columns.slice(0, currentIndex).reverse()[0] ||
			columns.slice(currentIndex + 1)[0] ||
			null
		);
	};

	const slugify = (text) => {
		return (
			text
				.normalize('NFKD')
				.replace(/[\u0300-\u036f]/g, '')
				.toLowerCase()
				.replace(/&/g, ' and ')
				.replace(/[^a-z0-9]+/g, '-')
				.replace(/^-+|-+$/g, '') || 'section'
		);
	};

	const ensureHeadingId = (heading) => {
		if (
			heading.id &&
			document.getElementById(heading.id) === heading
		) {
			return heading.id;
		}

		const baseId = `case-overview-${slugify(heading.textContent.trim())}`;
		let headingId = baseId;
		let suffix = 2;

		while (
			document.getElementById(headingId) &&
			document.getElementById(headingId) !== heading
		) {
			headingId = `${baseId}-${suffix}`;
			suffix += 1;
		}

		heading.id = headingId;

		return headingId;
	};

	navigationBlocks.forEach((block) => {
		const sourceColumn = findAdjoiningColumn(block);
		const list = block.querySelector('[data-case-overview-list]');

		if (!sourceColumn || !list) {
			return;
		}

		const headings = Array.from(sourceColumn.querySelectorAll('h2, h3')).filter(
			(heading) => heading.textContent.trim()
		);

		if (!headings.length) {
			return;
		}

		list.replaceChildren();

		headings.forEach((heading) => {
			const headingId = ensureHeadingId(heading);
			const item = document.createElement('li');
			const link = document.createElement('a');
			const linkText = document.createElement('span');

			heading.classList.add('case-overview-nav__target');
			item.className = 'case-overview-nav__item';
			link.className = 'case-overview-nav__link';
			link.href = `#${headingId}`;
			linkText.className = 'case-overview-nav__link-text';
			linkText.textContent = heading.textContent.trim();

			link.append(linkText);
			item.append(link);
			list.append(item);
		});

		block.classList.add('is-ready');
	});

	// Browsers resolve the initial hash before generated heading IDs exist.
	if (window.location.hash) {
		const targetId = decodeURIComponent(window.location.hash.slice(1));
		const initialTarget = document.getElementById(targetId);

		if (
			initialTarget &&
			initialTarget.classList.contains('case-overview-nav__target')
		) {
			window.requestAnimationFrame(() => initialTarget.scrollIntoView());
		}
	}
};

caseOverviewNavigation();

/**
 * Load scripts introduced only by the global footer form shortly before the
 * form enters the viewport. Their document order already reflects WordPress'
 * dependency resolution, so load them sequentially to preserve that order.
 */
const lazyFooterFormScripts = () => {
	const init = () => {
		const footerForm = document.querySelector('[data-ij-lazy-footer-form]');

		if (!footerForm) {
			return;
		}

		let loading = false;

		const loadScripts = () => {
			if (loading) {
				return;
			}

			loading = true;
			const holdGravityFormsInitialization =
				typeof window.gform !== 'undefined' && window.gform.domLoaded;

			if (holdGravityFormsInitialization) {
				window.gform.domLoaded = false;
			}

			const placeholders = Array.from(
				document.querySelectorAll('[data-ij-footer-form-script][data-ij-src]')
			);

			placeholders
				.reduce((sequence, placeholder) => {
					return sequence.then(
						() =>
							new Promise((resolve) => {
								const script = document.createElement('script');

								Array.from(placeholder.attributes).forEach((attribute) => {
									if (
										attribute.name === 'type' ||
										attribute.name === 'data-ij-src' ||
										attribute.name === 'data-ij-footer-form-script' ||
										attribute.name === 'defer' ||
										attribute.name === 'async'
									) {
										return;
									}

									script.setAttribute(attribute.name, attribute.value);
								});

								script.async = false;
								script.src = placeholder.dataset.ijSrc;
								script.addEventListener('load', resolve, { once: true });
								script.addEventListener('error', resolve, { once: true });
								placeholder.replaceWith(script);
							})
					);
				}, Promise.resolve())
				.then(() => {
					if (holdGravityFormsInitialization && window.gform) {
						window.gform.domLoaded = true;
						document.dispatchEvent(new Event('gform/theme/scripts_loaded'));
					}

					footerForm.classList.add('is-interactive');
				});
		};

		if (!('IntersectionObserver' in window)) {
			loadScripts();
			return;
		}

		const observer = new IntersectionObserver(
			(entries) => {
				if (!entries.some((entry) => entry.isIntersecting)) {
					return;
				}

				observer.disconnect();
				loadScripts();
			},
			{ rootMargin: '600px 0px' }
		);

		observer.observe(footerForm);
	};

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init, { once: true });
	} else {
		init();
	}
};

lazyFooterFormScripts();

/**
 * Marketing analytics is non-essential to the initial render. Activate the
 * inert tracker URLs after the first meaningful visitor interaction.
 */
const delayedMarketingTrackers = () => {
	let loaded = false;
	const load = () => {
		if (loaded) {
			return;
		}

		loaded = true;
		const trackers = Array.from(
			document.querySelectorAll('[data-ij-tracker][data-ij-src]')
		);
		trackers.forEach((placeholder) => {
			const script = document.createElement('script');
			script.async = true;
			script.src = placeholder.dataset.ijSrc;
			placeholder.replaceWith(script);
		});
	};

	['pointerdown', 'keydown', 'touchstart', 'wheel'].forEach((eventName) => {
		window.addEventListener(eventName, load, { once: true, passive: true });
	});
};

delayedMarketingTrackers();

/**
 * Enhance native podcast audio controls shortly before a PowerPress or core
 * audio player becomes visible. Loading remains sequential to preserve the
 * WordPress MediaElement dependency order.
 */
const lazyMediaElement = () => {
	const player = document.querySelector(
		'.powerpress_player, audio.wp-audio-shortcode, video.wp-video-shortcode'
	);
	const placeholders = Array.from(
		document.querySelectorAll('[data-ij-mediaelement-script][data-ij-src]')
	);

	if (!player || !placeholders.length) {
		return;
	}

	let loading = false;
	const load = () => {
		if (loading) {
			return;
		}

		loading = true;
		placeholders.reduce((sequence, placeholder) => {
			return sequence.then(
				() =>
					new Promise((resolve) => {
						const script = document.createElement('script');
						script.async = false;
						script.src = placeholder.dataset.ijSrc;
						script.addEventListener('load', resolve, { once: true });
						script.addEventListener('error', resolve, { once: true });
						placeholder.replaceWith(script);
					})
			);
		}, Promise.resolve());
	};

	player.addEventListener('pointerdown', load, { once: true, passive: true });
	player.addEventListener('focusin', load, { once: true });

	if (!('IntersectionObserver' in window)) {
		load();
		return;
	}

	const observer = new IntersectionObserver(
		(entries) => {
			if (entries.some((entry) => entry.isIntersecting)) {
				observer.disconnect();
				load();
			}
		},
		{ rootMargin: '800px 0px' }
	);

	observer.observe(player);
};

lazyMediaElement();

/**
 * Load the HEPdata employer-match widget only when its Kadence popup opens.
 * The V4 theme removes the vendor script from conversion content.
 *
 * Kadence fires kc-trigger-conversion only after it binds a goal control.
 * This popup's goal is .mg-forms-button, which HEPdata renders later, so
 * that event never fires. The kc-visible class is added before that check.
 */
const employerMatchWidget = () => {
	const conversion = document.getElementById('kadence-conversion-236417');
	const scriptSource =
		'https://matchbox.hepdata.com/edl/Institute_of_Justice_4635/bvojwq5r/script.js';

	if (!conversion) {
		return;
	}

	const mountPoint = conversion.querySelector('#edl-template');

	if (!mountPoint || !mountPoint.parentNode) {
		return;
	}

	const loadWidget = () => {
		if (!conversion.classList.contains('kc-visible')) {
			return;
		}

		if (document.querySelector(`script[src="${scriptSource}"]`)) {
			return;
		}

		const script = document.createElement('script');
		script.src = scriptSource;
		script.async = true;
		script.addEventListener(
			'error',
			() => {
				script.remove();
			},
			{ once: true }
		);

		mountPoint.parentNode.insertBefore(script, mountPoint);
	};

	conversion.addEventListener('kc-trigger-conversion', loadWidget);

	if ('MutationObserver' in window) {
		const observer = new MutationObserver(loadWidget);
		observer.observe(conversion, {
			attributes: true,
			attributeFilter: ['class'],
		});
	}

	loadWidget();
};

employerMatchWidget();


// restore Authorize.net card rules as PayPal only supports a subset and overrides the default rules
const restoreAuthorizeNetCardRules = ($) => {
	return {
		init() {
			// Only run if Gravity Forms is loaded
			if (typeof gform === 'undefined') {
				return;
			}

			// Hook into Gravity Forms' form rendering completion with setTimeout to run last
			$(document).on(
				'gform_post_render',
				() => {
					// This ensures our code runs after all other gform_post_render events have fired
					setTimeout(() => {
						this.restoreCardRules();
					}, 0);
				}
			);

		},

		restoreCardRules: function () {
			// Authorize.net supports all these card types
			const supported_cards = ['visa', 'mastercard', 'amex', 'discover'];

			// Define the complete card rules that Authorize.net would use
			const completeRules = {
				visa: ['4'],
				mastercard: ['51', '52', '53', '54', '55'],
				amex: ['34', '37'],
				discover: ['6011'],
			};

			// Create enhanced rules with all supported card types
			const enhanced_rules = {};
			supported_cards.forEach((cardSlug) => {
				if (completeRules[cardSlug]) {
					enhanced_rules[cardSlug] = completeRules[cardSlug];
				}
			});

			// Restore the rules to what Authorize.net would have set
			window['gf_cc_rules'] = enhanced_rules;
			//console.log('Card rules restored to Authorize.net defaults:', window['gf_cc_rules']);
		},
	};
};

// Only initialize if Gravity Forms is present
if (typeof gform !== 'undefined') {
	restoreAuthorizeNetCardRules(jQuery).init();
}
